import React from "react";

export default function VehicleInfoCards({ vehicle }) {
 

  const infoCards = [
    {
      label: "ENGINE",
      value: vehicle?.engine?.name || "N/A",
      subtitle: vehicle?.engine?.horsepower ? `${vehicle.engine.horsepower} Horsepower` : "",
    },
    {
      label: "TRANSMISSION",
      value: vehicle?.TransmissionType?.name || "N/A",
      subtitle: vehicle?.TransmissionType?.description || "",
    },
    {
      label: "MILEAGE",
      value: vehicle?.mileage ? `${Number(vehicle.mileage).toLocaleString()} mi` : "0 mi",
      subtitle: vehicle?.ownershipType || "",
    },
    {
      label: "CONDITION",
      value: vehicle?.Highlight?.name || "N/A",
      subtitle: vehicle?.titleStatus || "",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {infoCards.map((card, index) => (
        <div
          key={index}
          className="bg-[#1E293B] rounded-lg p-4 border border-gray-700"
        >
          <div className="text-gray-400 text-xs font-semibold uppercase tracking-wide mb-2">
            {card.label}
          </div>
          <div className="text-white text-lg font-bold mb-1">
            {card.value}
          </div>
        </div>
      ))}
    </div>
  );
}
